// İSG uzmanı portalı — self-profil (`GET /me`) okuma hook'u (api-contract §18.1).
//
// Header'da "Uzman Portalı | Firma" ve profil menüsünde ad-soyad için kullanılır.
// Oturum açık (RequireAuth altı) varsayılır; `enabled` yalnız **user** principal'da
// çağırır (yanlış principal ucu çağrılmaz — §18 scope izolasyonu). 401 → API client
// mevcut refresh rotasyonu/oturum-düşürme akışını yürütür (yeni akış icat edilmez);
// 4xx'te retry yok (queryClient varsayılanı). Profil nadiren değişir → uzun staleTime.

import { type MeDto, profileApi, useAuthStore } from '@isgportal/shared';
import { useQuery } from '@tanstack/react-query';
import { meKeys } from './meKeys';

export interface UseMeResult {
  /** Giriş yapan kullanıcının profili (yüklenene / hata olana dek `undefined`). */
  me: MeDto | undefined;
  isPending: boolean;
}

export function useMe(): UseMeResult {
  const principalType = useAuthStore((s) => s.principal?.principalType);
  const query = useQuery({
    queryKey: meKeys.me(),
    queryFn: () => profileApi.getMe(),
    enabled: principalType === 'user',
    retry: false,
    staleTime: 5 * 60_000,
  });

  return { me: query.data, isPending: query.isPending };
}
